import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import Router from 'root/router';
import Util from 'root/module/util';
import Svg_Icon from 'root/module/svg_icon';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'view/base';
import View_Menu from 'page/account/menu';
import Model_Branding from 'model/branding';

export default View.extend({
    tagName: 'section',

    uploads: {
        email_logo : '',
        app_logo   : '',
        favicon    : ''
    },

    views: {
        menu: {}
    },

    events: {
        'click a.prevent-default'              : 'preventDefault',
        'keyup input[name="sender_name"]'      : 'onSenderNameChange',
        'keyup input[name="sender_email"]'     : 'onSenderEmailChange',
        'keyup input[name="colour"]'           : 'onColourChange',
        'click .upload-logo-email'             : 'onUploadEmailLogo',
        'click .upload-logo-app'               : 'onUploadAppLogo',
        'click .upload-logo-favicon'           : 'onUploadFavicon',
        'click .email-logo-delete'             : 'onDeleteEmailLogo',
        'click .app-logo-delete'               : 'onDeleteAppLogo',
        'click .favicon-delete'                : 'onDeleteFaviconLogo',
        'change input[name=display_powered_by]': 'onChangePoweredBy',
        'click .account-upgrade'               : 'onAccountUpgrade',
        'change .email-logo-input'             : 'onSelectEmailLogo',
        'change .app-logo-input'               : 'onSelectAppLogo',
        'change .favicon-input'                : 'onSelectFavicon',
        'click .account-upgrade'               : 'onUpgradeAccount',
        'click .sender-email-confirm a'        : 'sendEmailConfirmation',
        'submit .branding-settings'            : 'onSubmit'
    },

    dom_handlers: {
        preventDefault: function(e) {
            e.preventDefault();
        },

        onUpgradeAccount: function(e) {
            Modals.choosePlan();
        },

        sendEmailConfirmation: function(e) {
            e.preventDefault();
            Modals.sendBrandingEmailConfirmation(this.model.get('sender_email'));
        },

        onSenderNameChange: function(e) {
            var sender_name = $(e.currentTarget).val().trim() || 'Userback';
            this.$el.find('.sender-name').text(sender_name);

            this.checkIsChanged();
        },

        onSenderEmailChange: function(e) {
            var sender_email = $(e.currentTarget).val().trim() || 'no-reply@userback.io';
            this.$el.find('.sender-email').text(sender_email);

            this.checkIsChanged();
        },

        onColourChange: function(e) {
            var colour = $(e.currentTarget).val().trim();

            if (Util.isValidHex(colour)) {
                this.$el.find('.email-content button').css('background', colour);
            } else if (colour === '') {
                this.$el.find('.email-content button').css('background', '');
            }

            this.checkIsChanged();
        },

        onChangePoweredBy: function(e) {
            var form_data = Form.getData(this.$el.find('.branding-settings'));

            var hide_powered_by = form_data.display_powered_by[0] === 0;

            if (hide_powered_by) {
                this.$el.find('.email-content .footer').hide();
            } else {
                this.$el.find('.email-content .footer').show();
            }

            this.checkIsChanged();
        },

        onAccountUpgrade: function(e) {
            Modals.choosePlan();
        },

        onUploadEmailLogo: function(e) {
            $('<input>')
                .attr('type', 'file')
                .attr('accept', 'image/png, image/jpeg')
                .addClass('hidden email-logo-input')
                .appendTo(this.$el).click();
        },

        onUploadAppLogo: function(e) {
            $('<input>')
                .attr('type', 'file')
                .attr('accept', 'image/png, image/jpeg')
                .addClass('hidden app-logo-input')
                .appendTo(this.$el).click();
        },

        onUploadFavicon: function(e) {
            $('<input>')
                .attr('type', 'file')
                .attr('accept', 'image/png, image/jpeg')
                .addClass('hidden favicon-input')
                .appendTo(this.$el).click();
        },

        onDeleteEmailLogo: function(e) {
            e.preventDefault();

            this.$el.find('.logo-preview-email').attr('src', '/image/logo.png');
            this.$el.find('.branding-logo-container-email').hide();

            this.uploads.email_logo = 'default';

            this.checkIsChanged();
        },

        onDeleteAppLogo: function(e) {
            e.preventDefault();

            this.$el.find('.logo-preview-app').attr('src', '/image/logo_square.png');
            this.$el.find('.branding-logo-container-app').hide();

            this.uploads.app_logo = 'default';

            this.checkIsChanged();
        },

        onDeleteFaviconLogo: function(e) {
            e.preventDefault();

            this.$el.find('.logo-preview-favicon').attr('src', '/image/logo_square.png');
            this.$el.find('.branding-logo-container-favicon').hide();

            this.uploads.favicon = 'default';

            this.checkIsChanged();
        },

        onSelectEmailLogo: function(e) {
            Util.readImage(e.target.files[0], 5, function(file_name, file_type, file_content) {
                this.$el.find('.logo-preview-email').attr('src', file_content);
                this.$el.find('.branding-logo-container-email').show();

                this.uploads.email_logo = file_content;

                this.checkIsChanged();
            }.bind(this));
        },

        onSelectAppLogo: function(e) {
            Util.readImage(e.target.files[0], 5, function(file_name, file_type, file_content) {
                this.$el.find('.logo-preview-app').attr('src', file_content);
                this.$el.find('.branding-logo-container-app').show();

                this.uploads.app_logo = file_content;

                this.checkIsChanged();
            }.bind(this));
        },

        onSelectFavicon: function(e) {
            Util.readImage(e.target.files[0], 5, function(file_name, file_type, file_content) {
                this.$el.find('.logo-preview-favicon').attr('src', file_content);
                this.$el.find('.branding-logo-container-favicon').show();

                this.uploads.favicon = file_content;

                this.checkIsChanged();
            }.bind(this));
        },

        onSubmit: function(e) {
            if (!this.canUseBranding()) {
                Modals.unlockFeature(false, 'Let\s go!');
                return;
            }

            var form_data = Form.getData(this.$el.find('.branding-settings'));
            form_data['id']         = this.model.id;
            form_data['email_logo'] = this.uploads.email_logo;
            form_data['app_logo']   = this.uploads.app_logo;
            form_data['favicon']    = this.uploads.favicon;
            form_data['display_powered_by'] = form_data.display_powered_by[0] !== 0;

            var submit_button = this.$el.find('.branding-settings').find('button[type="submit"]');

            submit_button.addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'branding/update',
                data: form_data,
                success: (response) => {
                    UI.success('Branding updated successfully');
                    this.onSaveBrandingSuccess(response);
                },
                complete: () => {
                    submit_button.removeClass('loading').prop('disabled', false);
                }
            });
        }
    },

    onSaveBrandingSuccess: function(response) {
        if (this.model.id) {
            this.model.set(response);
        } else {
            Cache.branding.add(response);
            this.model = Cache.branding.at(0);
        }

        if (this.model.get('sender_email') && !this.model.get('is_sender_email_confirmed')) {
            this.$el.find('.sender-email-confirm').show();
        } else {
            this.$el.find('.sender-email-confirm').hide();
        }
    },

    checkIsChanged: function() {
        if (!this.canUseBranding()) {
            return;
        }

        var is_changed = false;
        var form_data = Form.getData(this.$el.find('.branding-settings'));

        form_data['email_logo'] = this.uploads.email_logo;
        form_data['app_logo']   = this.uploads.app_logo;
        form_data['favicon']    = this.uploads.favicon;

        if (this.model.get('sender_name') !== form_data.sender_name ||
            this.model.get('sender_email') !== form_data.sender_email ||
            this.model.get('colour') !== form_data.colour) {
            is_changed = true;
        }

        if (form_data['email_logo']) {
            if (form_data['email_logo'] === 'default' && !this.model.get('email_logo')) {
            } else {
                is_changed = true;
            }
        }

        if (form_data['app_logo']) {
            if (form_data['app_logo'] === 'default' && !this.model.get('app_logo')) {
            } else {
                is_changed = true;
            }
        }

        if (form_data['favicon']) {
            if (form_data['favicon'] === 'default' && !this.model.get('favicon')) {
            } else {
                is_changed = true;
            }
        }

        var display_powered_by = form_data['display_powered_by'][0] !== 0;

        if (display_powered_by !== this.model.get('display_powered_by')) {
            is_changed = true;
        }

        this.$el.find('.branding-settings button[type="submit"]').prop('disabled', !is_changed);

    },

    initialize: function() {
        this.views.menu = new View_Menu();

        if (Cache.branding.length) {
            this.model = Cache.branding.at(0);
        } else {
            this.model = new Model_Branding();
        }
    },

    confirmBrandingEmail: function(code) {
        if (this.model.get('is_sender_email_confirmed')) {
            return;
        }

        Cache.app.request({
            action: 'branding/confirmEmail',
            data : {
                key: code
            },
            success: (response) => {
                this.model.set('is_sender_email_confirmed', true);

                UI.success('The sender email has been verified');
                this.$el.find('.sender-email-confirm').hide();
            }
        });
    },

    canUseBranding: function() {
        return Cache.account.hasFeature('white_label') ? true : false;
    },

    // powered by can be hidden
    canHidePoweredBy: function() {
        return Cache.account.hasFeature('powered_by') && !Cache.account.get('is_trial');
    },

    onPageReady: function() {
        var branding_type = Router.getQueryString('t');
        var email_confirm_code = Router.getQueryString('ecb');

        if (branding_type !== 'email') {
            this.$el.find('.tab-menu a[data-val="' + branding_type + '"]').click();
        }

        // do these in onPageReady so that .show knows to set display to inline-block becasue the element is already rendered
        if (this.model.get('email_logo')) {
            this.$el.find('.branding-logo-container-email').show();
        } else {
            this.$el.find('.branding-logo-container-email').hide();
        }

        if (this.model.get('app_logo')) {
            this.$el.find('.branding-logo-container-app').show();
        } else {
            this.$el.find('.branding-logo-container-app').hide();
        }

        if (this.model.get('favicon')) {
            this.$el.find('.branding-logo-container-favicon').show();
        } else {
            this.$el.find('.branding-logo-container-favicon').hide();
        }

        if (email_confirm_code) {
            this.confirmBrandingEmail(email_confirm_code);
        }
    },

    render: function() {
        UI.setPageTitle('Branding');

        var content = '';

        content += '<main class="xlarge">' +
                        '<div>Customize emails and feedback viewer with your logo, color and company details</div>' +
                        '<div class="divider-24"></div>' +
                        '<div class="box overflow-hidden">' +
                            '<div class="window-container">' +
                                '<div class="window-gmail">' +
                                    '<h4><span><img src="/image/gmail_logo.png">Email Preview</span></h4>' +
                                    '<div class="panel-email">' +
                                        '<div class="email-subject">' +
                                            '<span class="sender-name position-relative">' + (this.model.get('sender_name') || 'Userback') + '</span>' +
                                            '<span> &lt;</span>' +
                                            '<span class="sender-email">' + (this.model.get('sender_email') || 'no-reply@userback.io') + '</span>' +
                                            '<span>&gt;</span>' +
                                            '</div>' +
                                        '<div class="email-to">to me <i class="fas fa-caret-down"></i></div>' +
                                        '<div class="email-content">' +
                                            '<div class="container">' +
                                                '<div class="header">' +
                                                    '<img class="logo-preview-email">' +
                                                '</div>' +
                                                '<div class="body">' +
                                                    '<div class="placeholder-text"></div>' +
                                                    '<div class="placeholder-text"></div>' +
                                                    '<div class="placeholder-text-short"></div>' +
                                                    '<div class="text-align-center margin-top-24">' +
                                                        '<button class="primary medium"><div class="placeholder-text-light" style="width:50px;"></div></button>' +
                                                    '</div>' +
                                                '</div>' +
                                                '<div class="footer">' +
                                                    '<span>Powered by</span>' +
                                                    '<span>' + Svg_Icon.logo + '</span>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="divider-24"></div>' +
                                '<div class="window-gmail">' +
                                    '<h4>' +
                                        '<span><img class="logo-preview-favicon">Feedback Preview</span>' +
                                    '</h4>' +
                                    '<div class="viewer-header">' +
                                        '<img class="logo-preview-app">' +
                                        '<div class="feedback-id-preview"><div class="placeholder-text"></div></div>' +
                                    '</div>' +
                                    '<div class="viewer-body">' +
                                        '<div class="viewer-screenshot"></div>' +
                                        '<div class="viewer-details">' +
                                            '<div class="placeholder-text"></div>' +
                                            '<div class="placeholder-text"></div>' +
                                            '<div class="placeholder-text"></div>' +
                                            '<div class="placeholder-text"></div>' +
                                            '<div class="placeholder-text-short"></div>' +
                                            '<div class="placeholder-text-short"></div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +

                            '<form class="branding-settings form-fluid">' +
                                '<div class="row">' +
                                    '<div class="field-label">Sender Name</div>' +
                                    '<input type="text" class="solid medium" name="sender_name" placeholder="Userback" maxlength="50">' +
                                '</div>' +
                                (Cache.branding.length && Cache.branding.at(0).get('sender_email') ?
                                '<div class="row">' +
                                    '<div class="field-label">Sender Email</div>' +
                                    '<div class="banner-warning tooltip" data-title="Customizing the Sender Email is no longer supported due to changed authentication and security requirements of major email providers.">' +
                                        'Customizing the Sender Email is no longer supported and causes delivery issues.<br />Once removed it will no longer be configurable on your account.</div><br />' +
                                    '<input type="email" class="solid medium" name="sender_email" placeholder="no-reply@userback.io">' +
                                    '<div class="sender-email-confirm"><i class="fas fa-info-circle"></i> <a href="#">Confirm email address</a></div>' +
                                '</div>' : '') +
                                '<div class="row">' +
                                    '<div class="field-label">Color</div>' +
                                    '<input type="text" class="colour solid medium" name="colour" placeholder="#6042EC" spellcheck="false">' +
                                '</div>' +
                                '<div class="row">' +
                                    '<div class="field-label">Email Header</div>' +
                                    '<div class="text-info text-medium margin-bottom-12">Image height: 28 pixels</div>' +
                                    '<div class="branding-logo-container branding-logo-container-email">' +
                                        '<a href="#" class="email-logo-delete tooltip" data-title="Delete"><i class="fas fa-times-circle"></i></a>' +
                                        '<img class="logo-preview-email">' +
                                    '</div>' +
                                    '<div>' +
                                        '<button type="button" class="upload-logo-email tertiary medium square fluid text-align-left"><i class="fa-solid fa-upload"></i> Upload</button>' +
                                    '</div>' +
                                '</div>' +

                                '<div class="row">' +
                                    '<div class="flex-between">' +
                                        '<div class="field-label">Powered by Userback</div>' +
                                        (this.canHidePoweredBy() || !this.canUseBranding() ? '' :
                                        '<button type="button" class="account-upgrade tiny shiny"><span>UPGRADE</span></button>') +
                                    '</div>' +
                                    '<div><input type="checkbox" class="update-click" name="display_powered_by" id="display_powered_by" value="0"><label for="display_powered_by">Hide "Powered by Userback"</label></div>' +
                                '</div>' +

                                '<hr>' +

                                '<div class="row">' +
                                    '<div class="field-label">App Logo</div>' +
                                    '<div class="text-info text-medium margin-bottom-12">Image height: 28 Pixels</div>' +
                                    '<div class="branding-logo-container branding-logo-container-app">' +
                                        '<a href="#" class="app-logo-delete tooltip" data-title="Delete"><i class="fas fa-times-circle"></i></a>' +
                                        '<img class="logo-preview-app">' +
                                    '</div>' +
                                    '<div>' +
                                        '<button type="button" class="upload-logo-app tertiary medium square fluid text-align-left"><i class="fa-solid fa-upload"></i> Upload</button>' +
                                    '</div>' +
                                '</div>' +

                                '<div class="row">' +
                                    '<div class="field-label">Favicon</div>' +
                                    '<div class="text-info text-medium margin-bottom-12">Recommended size: 16 x 16 pixels</div>' +
                                    '<div class="branding-logo-container branding-logo-container-favicon">' +
                                        '<a href="#" class="favicon-delete tooltip" data-title="Delete"><i class="fas fa-times-circle"></i></a>' +
                                        '<img class="logo-preview-favicon">' +
                                    '</div>' +
                                    '<div>' +
                                        '<button type="button" class="upload-logo-favicon tertiary medium square fluid text-align-left"><i class="fa-solid fa-upload"></i> Upload</button>' +
                                    '</div>' +
                                '</div>' +

                                '<hr>' +

                                (this.canUseBranding() ?
                                '<div class="margin-top-48">' +
                                    '<button type="submit" class="primary" disabled>Save Settings</button>' +
                                '</div>' :
                                '<div class="flex-start">' +
                                    '<button type="button" class="account-upgrade shiny medium"><span>Upgrade my plan</span></button>' +
                                    '<div class="text-info text-medium margin-left-8">This feature is not available in your plan.</div>' +
                                '</div>') +
                            '</form>' +
                        '</div>' +
                    '</main>';

        this.$el.html(content);

        if (this.model.get('sender_email') && !this.model.get('is_sender_email_confirmed')) {
            this.$el.find('.sender-email-confirm').css('display', 'block');
        }

        if (this.model.get('colour')) {
            this.$el.find('.email-content button').css('background', this.model.get('colour'));
        }

        if (!this.canHidePoweredBy()) {
            this.$el.find('[name=display_powered_by]').prop('disabled', true);
        }

        if (this.model.get('display_powered_by')) {
            this.$el.find('.email-content .footer').show();
        } else {
            this.$el.find('.email-content .footer').hide();
        }

        Form.setData(this.$el.find('form.branding-settings'), {
            sender_name    : this.model.get('sender_name'),
            sender_email   : this.model.get('sender_email'),
            colour         : this.model.get('colour'),
            app_logo       : this.model.get('app_logo'),
            favicon        : this.model.get('favicon'),
            display_powered_by: this.model.get('display_powered_by') ? [1]: [0],
        });

        this.$el.find('.logo-preview-email').attr('src',   this.model.get('email_logo') || '/image/logo.png');
        this.$el.find('.logo-preview-app').attr('src',     this.model.get('app_logo')   || '/image/logo_square.png');
        this.$el.find('.logo-preview-favicon').attr('src', this.model.get('favicon')    || '/image/logo_square.png');

        if (!this.canUseBranding()) {
            this.$el.find('form input').prop('disabled', true);
            this.$el.find('form button.tertiary').prop('disabled', true);
        }

        this.views.menu.render().$el.prependTo(this.$el.find('main'));

        return this;
    }
});